import React from 'react';

import classes from './ButtonIcon.css';

const buttonIcon = (props) => (
  <button
    className={[classes.Button, props.btnClass, props.btnType ? classes[props.btnType] : null, props.small ? classes.Small : null].join(' ')}
    onClick={props.clicked}
    style={props.style}
    disabled={props.disabled}>
    <img className={props.iconClass} src={props.iconSource} alt={props.iconAlt} />
    <p className={classes.ButtonText}>{props.children}</p>
  </button>
);

export default buttonIcon;



// WEBPACK FOOTER //
// ./src/components/UI/ButtonIcon/ButtonIcon.js